import state from './moduleGiftManagementState.js'
import mutations from './moduleGiftManagementMutations.js'
import actions from './moduleGiftManagementActions.js'
import getters from './moduleGiftManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

